<template>
    <div v-if="object!=null" class="ui segment" style="padding:0px">
        <div v-if="object.relationship_type=='identification' && object.hasOwnProperty('cert')" class="certainty" v-bind:class="{high:object.cert=='high',medium:object.cert=='medium',low:object.cert=='low'}">
            <span style="font-weight: bold;">Identified Artwork</span> – certainty: {{object.cert}}
        </div>
        <div v-if="object.relationship_type=='resembling'" class="certainty" style="font-weight: bold; background-color: #b3b3b3">Resembling Object</div>
        <div v-if="object.relationship_type=='related'" class="certainty" style="font-weight: bold; background-color: #b3b3b3">Related Item</div>
        <span v-if="object.relationship_type=='identification' || object.relationship_type=='related'">
            <TheCarousel v-bind:slides="slides" @openModal="openModal" type='item'></TheCarousel><br>
        </span>
        <div v-if="object.relationship_type=='resembling'" style="position:relative">
            <TheCarousel v-bind:slides="slides" @openModal="openModal" type='item'></TheCarousel>
            <div class="similar_artwork">Resembling Object</div><br>
        </div>

        <h4 v-if="type=='related'" style="margin:0px">{{object.object_name}}</h4>
        <span v-if="type=='related' && hasOwnDeepPropertyv2(object,'name[0].getty_data.display_name')">{{object.name[0].getty_data.display_name}}<br><br></span>
        <p id="object_info" style="padding:0px 14px 0px 14px">
            <span v-if="object.hasOwnProperty('name')"><span class="gray">Author:</span><br><span>{{object.name[0].getty_data.display_name}}<br><br></span></span>
            <span v-if="object.hasOwnProperty('caption')"><span class="gray">Title:</span><br><span style="font-weight: bold;">{{object.caption}}<span v-if="object.hasOwnProperty('origDate')" style="font-weight: normal;">, {{object.origDate}}</span><br><br></span></span>
            <span v-if="object.hasOwnProperty('institution')"><span class="gray">Institution:</span><br><span>{{object.institution}}<br></span></span>
            <span v-if="object.hasOwnProperty('id_number')">Inv. No. {{object.id_number}}<br></span>
            <span v-else><br></span>
            <span v-if="object.hasOwnProperty('city')">{{object.city}}
                <span v-if="object.hasOwnProperty('country')">({{object.country}})</span><br><br>
            </span>
            <span v-else-if="object.hasOwnProperty('country')">{{object.country}}<br><br></span>
            <span v-if="object.hasOwnProperty('repository')"><span class="gray">Repository:<br></span><span>{{object.repository}}<br><br></span></span>
            <span v-if="object.hasOwnProperty('provenance')"><span class="gray">Provenance:<br></span><span>{{object.provenance}}<br><br></span></span>

            <span v-if="object.hasOwnProperty('material') && !object.hasOwnProperty('dimensions') "><span class="gray">Material:<br></span><span>{{object.material}}<br><br></span></span>
            <span v-if="object.hasOwnProperty('material') && object.hasOwnProperty('dimensions')">
                <span class="gray">Material and Size:<br></span>
                <span v-if="!object.dimensions.hasOwnProperty('dim')">{{object.material}}; {{object.dimensions.height}} × {{object.dimensions.width}}&nbsp;{{object.dimensions.unit}}</span>
                <span v-if="object.dimensions.hasOwnProperty('dim')">{{object.material}}; {{object.dimensions.dim}}&nbsp;{{object.dimensions.unit}} (diameter)</span>
                <br><br>
                <span>
                    <TheManAndArt v-if="!object.dimensions.hasOwnProperty('dim')" figure_height="120" v-bind:height="object.dimensions.height" v-bind:width="object.dimensions.width" v-bind:unit="object.dimensions.unit" figure="rudolf" v-bind:display_image="true" v-bind:src="'/static/images/'+object.images[0].file"></TheManAndArt>
                    <TheManAndArt v-if="object.dimensions.hasOwnProperty('dim')" figure_height="120" v-bind:height="object.dimensions.dim" v-bind:width="object.dimensions.dim" v-bind:unit="object.dimensions.unit" figure="rudolf" v-bind:display_image="true" v-bind:src="'/static/images/'+object.images[0].file" v-bind:circle="true"></TheManAndArt>
                </span>
            </span>
            <span v-if="object.hasOwnProperty('physical_description')"><span class="gray">Description:<br></span><span v-html="decodeURIComponent(object.physical_description)"></span><br><br></span>
        </p>

    </div>
</template>

<script>
    import TheCarousel from './TheCarousel.vue'
  //  import TheSimpleModal from './TheSimpleModal.vue'
    import TheManAndArt from './TheManAndArt.vue'
    export default {
        props: ['object', 'type'],
        data() {
            return {
                slides: [],
                modalisOpened:false,

            }
        },

        methods: {
            hasOwnDeepProperty: function(obj, path) {
                var arr;
                for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
                    arr = path[i].match(/(.+)\[(\d+)\]/mi);
                    if (arr != null) {
                        if (arr.length == 3) {
                            if (obj[arr[1]]) obj = obj[arr[1]][arr[2]];
                            else return false;
                        }
                    }
                    else obj = obj[path[i]];
                    if (!obj) return false;
                };
                return true;
            },

            hasOwnDeepPropertyv2: function(obj, path) {
                path = path.split('.');
                for (var i in path) {
                    if (path[i].match(/\[\d+\]/mi) == null) {
                        if (obj.hasOwnProperty(path[i])) {
                            obj = obj[path[i]];
                        }
                        else {
                            return false
                        }
                    }
                    else {
                        var matchArr = path[i].match(/\[(\d+)\]/mi);
                        obj = obj[path[i].replace(/\[\d+\]/mi, '')];
                        if (obj != undefined) {
                            obj = obj[matchArr[1]]
                        }
                        else {
                            return false
                        }
                    }
                }
                return true
            },

            createCarouselSlides: function() {
                this.slides = [];
                var slide = {};
                if (this.object.hasOwnProperty('images')) {
                    for (var i in this.object.images) {
                        slide = {};
                        slide.src = '/static/images/' + this.object.images[i].file;
                        slide.title = this.object.images[i].text;
                        slide.itemid = false;
                        slide.id = parseInt(i);
                        this.slides.push(slide);
                    }
                }
            },
        /*    openGallery: function(file) {
                this.$emit('openGallery', file);
            },*/
             openModal: function(file) {
              this.modalisOpened=true
            },
            highLight: function(id) {
                document.getElementById(id).style.opacity = 1;
                document.getElementById(id.replace('ph', 'sa')).style.display = 'none';

            },
            lowLight: function(id) {
                document.getElementById(id).style.opacity = 0.7;
                document.getElementById(id.replace('ph', 'sa')).style.display = 'block';

            }


        },
        beforeMount() {
            this.createCarouselSlides();
        },

        mounted() {
           
        },
        components: {
            TheCarousel,
      //      TheSimpleModal,
            TheManAndArt
        },
        watch: {
            object: function(to, from) {
               
                    this.createCarouselSlides();
                
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .italic {
        font-style: italic;
    }

    .certainty {
      /*  position: absolute;
        top: 0px;
        left: 0px;*/
        width: 100%;
        padding: 0.18em 1em;
       
    }

    .high {
        background-color: rgb(174, 223, 181)
    }

    .medium {
        background-color: rgb(255, 216, 179)
    }

    .low {
        background-color: #FFAAAA
    }

    .placeholder {
        background-color: #b3b3b3
    }

    .certainty_padding {
        padding: 3em 0px 0px 0px;
        
    }

    .gray {
        color: #999999;
    }

    .similar_artwork {
        position: absolute;
        bottom: 1rem;
        text-align: center;
        background-color: rgb(255, 255, 255);
        height: 3rem;
        opacity: 0.7;
        padding: 0.5em;
        width: 100%;

    }
</style>



// WEBPACK FOOTER //
// src/components/TheGalleryItem.vue